export default "__VITE_ASSET__BYBbCT9c__"